import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelectionList, MatInput, MatDialog, MatSelectModule } from '@angular/material';
import { Shift } from '../../../shift';
import { PositionService } from '../../../position.service';
import { PositionAssignmentsService } from '../../../position-assignments.service';
import { DatePipe } from '@angular/common';
import { Position } from '../../../position';
import { TransactionService } from '../../../transaction.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  shift: Shift;
  shifts: Shift[];
  position: Position;
  selectedDate: any;
  dateLine: Date;
  isInspector = false;
  startTime = '';
  endTime = '';
  confirmablePositions: any[] = [];
  source = 0;
  siteId = '0';
  siteName = '';
  selectedShift = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private positionService: PositionService,
    private positionAssignmentService: PositionAssignmentsService,
    private transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.shift = this.data.shift;
    this.shifts = this.data.shifts;
    this.selectedShift = this.shift.name;
    for (const item of this.shift.positions) {
      if (item.isMulti === 0 && item.isOverflow === 0 && item.status === 1) {
        this.confirmablePositions.push(item);
      }
    }
    this.isInspector = this.data.isInspector;
    this.position = this.data.item;
    this.selectedDate = new Date(new Date(this.data.date).getTime() + 1000 * 60 * 60 * 24);
    this.dateLine = this.selectedDate;
    this.startTime = this.data.startTime;
    this.endTime = this.data.endTime;
    this.source = this.data.source;
    this.siteId = this.data.siteId;
    this.siteName = this.data.siteName;
  }

  setUpDefaults() {

  }

  changeDate(t: any): void {
    if (t.value) {
      if (t.value >= this.dateLine) { // if date selected is greater than selected date
        this.selectedDate = t.value;
      } else {
        this.selectedDate = this.dateLine;
      }
    } else { // if something is wrong
      this.selectedDate = this.dateLine;
    }
  }

  confirmClicked() {
    if (this.source === 0) {
      const datePipe = new DatePipe('en');
      this.positionService.addPosition(
        this.siteId,
        datePipe.transform(this.selectedDate, 'yyyy-MM-dd'),
        this.selectedShift,
        this.startTime,
        this.endTime,
        localStorage.getItem('userFullName'),
        '1',
        this.position.requirement,
        this.position.workArea || ''
      )
        .subscribe((data) => {
          const holder: any = data;

          // exit modal
          this.dialogRef.close({
            result: 'confirmed',
            selectedDate: this.selectedDate,
            id: holder[0].lastId
          });
          this.positionAssignmentService.addPositionAssignment(holder[0].lastId, '0',
          (this.position.assignments ? this.position.assignments[0].inspectorId : this.position['inspectorId']),
            '0', localStorage.getItem('userFullName'))
            .subscribe((assignmentData) => {
            }
          );
        }
      );
      this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift,
        'Inspector ' + (this.position.assignments ? this.position.assignments[0].inspectorName : this.position.name )
        + ' confirmed to the ' + this.selectedShift +
        ' shift on the next available work day (' + datePipe.transform(this.selectedDate, 'yyyy-MM-dd') +
        ') at ' + this.siteName)
        .subscribe((tdata) => {
        }
      );
    } else {
      const datePipe = new DatePipe('en');
      for (const item of this.confirmablePositions) {
        this.positionService.addPosition(
          this.siteId,
          datePipe.transform(this.selectedDate, 'yyyy-MM-dd'),
          this.selectedShift,
          item.start,
          item.end,
          localStorage.getItem('userFullName'),
          '1',
          item.requirement,
          item.workArea || ''
        )
          .subscribe((data) => {
            const holder: any = data;

            // exit modal
            this.dialogRef.close({
              result: 'confirmed',
              selectedDate: this.selectedDate
            });

            this.positionAssignmentService.addPositionAssignment(holder[0].lastId, '0',
            (item.assignments ? item.assignments[0].inspectorId : item.inspectorId),
             '0',
              localStorage.getItem('userFullName'))
              .subscribe((assignmentData) => {
              }
            );
          }
        );
        this.transactionService.addTransaction(localStorage.getItem('userFullName'), this.siteId, this.selectedShift,
          'Inspector ' +
          (item.assignments ? item.assignments[0].inspectorName : item.inspectorName)
          + ' confirmed to the ' + this.selectedShift +
          ' shift on the next available work day (' + datePipe.transform(this.selectedDate, 'yyyy-MM-dd') +
          ') at ' + this.siteName)
          .subscribe((tdata) => {
          }
        );
      }
    }
  }

  closeClicked() {
    this.dialogRef.close({result: 'cancelled'});
  }

  shiftDropdownClicked(shift: Shift) {
    this.selectedShift = shift.name;
    this.startTime = shift.start;
    this.endTime = shift.end;
  }
}
